export default __webpack_public_path__ + "media/images/images_v2/iui/toolButton-4291e9416a28c18bdd5e474a1c183fc1.png";